import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router';
import App from './App';
import { AuthenticatedQueryProvider } from './components/AuthenticatedQueryProvider';
import { ThemeProvider } from './components/ThemeProvider';
import { GlobalLoadingOverlay } from './components/common/GlobalLoadingOverlay';
import './index.css';
import './offline/install';
import { registerOfflineWorker } from './offline/worker';
import { installGlobalErrorHandlers } from './services/error-reporting';
import { useAuthStore } from './stores/auth.store';

installGlobalErrorHandlers();
registerOfflineWorker();

function AuthBootstrap() {
  React.useEffect(() => {
    void useAuthStore.getState().checkAuth();
  }, []);
  return null;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthBootstrap />
    <AuthenticatedQueryProvider>
      <ThemeProvider>
      <BrowserRouter>
        <App />
        <GlobalLoadingOverlay />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#1e293b',
              color: '#f8fafc',
            },
            success: {
              iconTheme: {
                primary: '#22c55e',
                secondary: '#f8fafc',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#f8fafc',
              },
            },
          }}
        />
      </BrowserRouter>
      </ThemeProvider>
    </AuthenticatedQueryProvider>
  </React.StrictMode>,
);
